// headlines.js — "DESIGN IN" / "MOTION" rendered as textured planes INSIDE the
// Three.js scene (not DOM). Living in the same depth buffer as the helix cards
// means the ribbon truly weaves around the title: cards nearer the camera
// (z > 0) occlude the letters, farther cards (z < 0) are occluded by them.
import * as THREE from 'three';

// draw one line of text onto a high-DPI canvas → texture (+ its aspect ratio)
function textTexture(text) {
  const dpr    = 2;
  const fontPx = 256;                       // big → crisp when scaled in 3D
  const font   = `700 ${fontPx}px "Helvetica Neue", Arial, sans-serif`;

  const measure = document.createElement('canvas').getContext('2d');
  measure.font = font;
  const w = Math.ceil(measure.measureText(text).width) + fontPx * 0.25;
  const h = Math.ceil(fontPx * 1.25);

  const canvas  = document.createElement('canvas');
  canvas.width  = Math.ceil(w * dpr);
  canvas.height = Math.ceil(h * dpr);
  const ctx = canvas.getContext('2d');
  ctx.scale(dpr, dpr);
  ctx.font = font;
  ctx.fillStyle = '#ffffff';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(text, w / 2, h / 2);

  const tex = new THREE.CanvasTexture(canvas);
  tex.colorSpace      = THREE.SRGBColorSpace;
  tex.minFilter       = THREE.LinearFilter;
  tex.generateMipmaps = false;
  tex.anisotropy      = 8;
  return { tex, aspect: w / h };
}

function makeLine(text, worldHeight) {
  const { tex, aspect } = textTexture(text);
  const geo = new THREE.PlaneGeometry(worldHeight * aspect, worldHeight);
  const mat = new THREE.MeshBasicMaterial({
    map: tex,
    transparent: true,   // letters keep their 0.82 ink opacity
    alphaTest: 0.3,       // gaps between letters are discarded → don't occlude cards
    depthTest: true,
    depthWrite: true,
    side: THREE.DoubleSide,
  });
  return new THREE.Mesh(geo, mat);
}

// build the two-line title, centred at the helix core (z = 0)
export function buildHeadlines() {
  const group  = new THREE.Group();
  const top    = makeLine('WORK THAT', 1.9);
  const bottom = makeLine('MOVES', 1.9);
  top.position.set(0,  1.55, 0);
  bottom.position.set(0, -1.15, 0);
  group.add(top, bottom);

  // subtle opposing drift keeps the centred title alive as the ribbon winds past
  function update(p) {
    top.position.x    = p * -0.6;
    bottom.position.x = p *  0.6;
  }
  function dispose() {
    [top, bottom].forEach((m) => {
      m.geometry.dispose();
      m.material.map.dispose();
      m.material.dispose();
    });
  }
  return { group, update, dispose };
}
